import { ref } from "vue";
import { adminV1OrganizationsPaymentsSubscriberMembershipsScheduledPaymentsRefundCreate } from "@/api/admin-payments-scheduled-payments/admin-payments-scheduled-payments";
import { useCurrentOrganization } from "@/composables/useCurrentOrganization";

export function useRefundScheduledPayment() {
  const { currentOrganizationId } = useCurrentOrganization();
  const isLoading = ref(false);
  const errorMessage = ref("");

  const refundScheduledPayment = async (
    subscriberMembershipId: string,
    scheduledPaymentId: string
  ) => {
    if (!currentOrganizationId.value) {
      errorMessage.value = "No organization selected";
      return;
    }

    isLoading.value = true;
    errorMessage.value = "";

    try {
      await adminV1OrganizationsPaymentsSubscriberMembershipsScheduledPaymentsRefundCreate(
        currentOrganizationId.value,
        subscriberMembershipId,
        scheduledPaymentId
      );
    } catch (error: unknown) {
      errorMessage.value =
        (error as Error)?.message || "Failed to refund scheduled payment";
    }

    isLoading.value = false;
  };

  return {
    isLoading,
    errorMessage,
    refundScheduledPayment,
  };
}
